import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Icon } from '@material-ui/core';

export default function SimpleMenu({ languageHandler, context }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [currentVal, setCurrentVal] = React.useState()

  useEffect(() => {
    let localLanguage = localStorage.getItem('language');
    if (localLanguage != null) {
       setCurrentVal(languageConvertorToChar(localLanguage));
    } else {
      setCurrentVal("EN");
    }
  }, [])

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const languageConvertorToNumber = (value) => {
    let lang = 2;
    if (value == 'EN') {
      lang = 2;
    } else if (value == 'Ar') {
      lang = 1;
    } else if (value == 'Ku') {
      lang = 0;
    }

    return lang;
  }

  const languageConvertorToChar = (value) => {
    let lang = "EN";
    if (value == 2) {
      lang = "EN";
    } else if (value == 1) {
      lang = "Ar";
    } else if (value == 0) {
      lang = "Ku";
    }

    return lang;
  }

  const handleClose = value => {
    // let value = e.nativeEvent.target.outerText
    setAnchorEl(null);
    if (value == "") {
      value = currentVal;
    }

    let lang = languageConvertorToNumber(value);

    if (typeof value === "string") {
      context.setLanguage(lang)
      setCurrentVal(value);
      languageHandler(lang);
    }
  };

  return (
    <div>
      <div onClick={handleClick} className={"header-drawer"}>
        {currentVal}
      </div>
      <Menu
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={() => handleClose('EN')}>EN</MenuItem>
        <MenuItem onClick={() => handleClose('Ar')}>Ar</MenuItem>
        <MenuItem onClick={() => handleClose('Ku')}>Ku</MenuItem>
      </Menu>
    </div>
  );
}
